import { LogsBase } from "~/areas/configuration/components/Diagnostics/Logs/LogsBase";
export class ScheduledDeployLogsPage extends LogsBase {
    constructor(props: {}) {
        super("ProcessRecurringScheduledDeployments", "Scheduled Trigger Logs", props);
    }
}
